import React from "react";
import { Outlet } from "react-router-dom";
import "./platform-layout.scss";

const PlatformLayout = () => {
  return (
    <div className="platformLayout-content">
      <Outlet />
    </div>
  );
};

export default PlatformLayout;
